import React, { useState } from 'react';
import styles from '../../../styles/hardware-partners/hardwarePartner.module.css';
import { AdvanceAnalyticsBanner, BlackCustomButton, HardwareFeatures, HardwareTab, MarqueeComponentHomePage, Tabs, TransparentCustomButton, WhiteCustomButton } from '@/components/qbStrap';
import Image from 'next/image';
import OutletFeatures from '@/components/common/OutletFeatures';
import { ClientsArr1, testimonialData, zomatoFeatures, videoTestimonial, zomatoFAQ, swiggyFAQ, swiggyFeatures , getTitleContent } from '@/constants/common';
import ThreeStepForm from '@/components/common/ThreeStepForm';
import TestimonialSection from '@/components/common/TestimonialSection';
import TrustFactor from '@/components/common/TrustFactor';
import FrequentQuestions from '@/components/homePage/FrequentQuestions';
import PersonalisedDemoBanner from '@/components/common/PersonalisedDemoBanner';
import VerificationPopup from '@/components/modals/VerificationPopup';
import { useRouter } from 'next/router';
import content from '../../../language/ENGLISH.json';

const DesktopSwiggy = () => {

    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const router = useRouter();

    const { commonMarqueTitle } = getTitleContent();

    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <div className={styles.hardware_logo} style={{ width: "12rem" }}><Image src="/assets/SWIGGY.webp" alt="SWIGGY" fill /></div>
                    <h1 className={styles.page_heading}>
                        <span className={styles.small_black_text}>Optimise and Automate Your Swiggy Orders</span><br />
                        <span className={styles.black_text}>Using</span><span className={styles.blue_text}> QueueBuster</span>
                    </h1>
                    <p className={styles.page_desc}>QueueBuster seamlessly integrates with Swiggy to relay your orders, enabling automatic acceptance and streamlining your order processing.</p>

                    <div className={styles.btn_container}>
                        <BlackCustomButton text="Try It Free" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("14 Days free trial"))} />
                        <TransparentCustomButton text="Contact Sales" style={{ padding: "0 2rem" }} onClick={() => (setDemoModal(true), setHeading("Contact Sales"))} />
                    </div>
                </div>
                <div className={styles.hero_img} style={{ height: "38rem" }}><Image src="/assets/software-partners/swiggy/hero-img.webp" alt="tvse" fill /></div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>

            <div className={styles.portable_devices}>
            <div className={styles.section_heading}><h3>Sizzle, Stir, Swiggy; With QueueBuster Restaurant POS Integration</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                {/* <h2>Sizzle, Stir, Swiggy; With QueueBuster Restaurant POS Integration</h2> */}
                <HardwareFeatures features={swiggyFeatures} setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
            <AdvanceAnalyticsBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            <div style={{ margin: "0 9.3rem" }}><ThreeStepForm /></div>

            <div style={{ margin: "5rem 6rem" }}><TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /></div>
            <TrustFactor />

            <FrequentQuestions FaqTableData={swiggyFAQ} heading={"FAQs for Swiggy Integration with QueueBuster"} />
            <div style={{ margin: "0 9.3rem" }}><PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} /></div>
        </>
    )
}

export default DesktopSwiggy